export default __webpack_public_path__ + "static/media/PolygonLuminary.c8aecc89.svg";